/* eslint-disable linebreak-style */
export default {
  translated: {
    US: 'USA',
    CA: 'Canada',
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algerie',
    AS: 'Amerikansk Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarktis',
    AG: 'Antigua og/eller Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Østerrike',
    AZ: 'Aserbajdsjan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Hviterussland',
    BE: 'Belgia',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia og Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvetøya',
    BR: 'Brasil',
    IO: 'Britisk territorium i det indiske hav',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Kambodsja',
    CM: 'Kamerun',
    CV: 'Kapp Verde',
    KY: 'Caymanøyene',
    CF: 'Den sentralafrikanske republikk',
    TD: 'Tsjad',
    CL: 'Chile',
    CN: 'Kina',
    CX: 'Juleøya',
    CC: 'Kokosøyene (Keeling).',
    CO: 'Colombia',
    KM: 'Komorene',
    CG: 'Kongo',
    CK: 'Cook-øyene',
    CR: 'Costa Rica',
    HR: 'Kroatia (Hrvatska)',
    CU: 'Cuba',
    CY: 'Kypros',
    CZ: 'Tsjekkisk Republikk',
    CD: 'Den demokratiske republikken Kongo',
    DK: 'Danmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Den Dominikanske republikk',
    TP: 'Øst-Timor',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Ekvatorial-Guinea',
    ER: 'Eritrea',
    EE: 'Estland',
    ET: 'Etiopia',
    FK: 'Falklandsøyene (Malvinas)',
    FO: 'Færøyene',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrike',
    FX: 'Frankrike, Metropolitan',
    GF: 'Fransk Guyana',
    PF: 'Fransk Polynesia',
    TF: 'Franske Sørlige Territorier',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Tyskland',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Hellas',
    GL: 'Grønland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard and Mc Donald Islands',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Ungarn',
    IS: 'Island',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran (den islamske republikken)',
    IQ: 'Irak',
    IE: 'Irland',
    IL: 'Israel',
    IT: 'Italia',
    CI: 'Elfenbenskysten',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Korea, Den demokratiske folkerepublikken',
    KR: 'Korea, Republikken',
    KW: 'Kuwait',
    KG: 'Kirgisistan',
    LA: 'Lao folkets Demokratiske Republikk',
    LV: 'Latvia',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Litauen',
    LU: 'Luxembourg',
    MO: 'Macau',
    MK: 'Macedonia',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldivene',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshalløyene',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    TY: 'Mayotte',
    MX: 'Mexico',
    FM: 'Fødererte Stater av Mikronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    MS: 'Montserrat',
    MA: 'Marokko',
    MZ: 'Mosambik',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Nederland',
    AN: 'De nederlandske Antillene',
    NC: 'Ny Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolkøya',
    MP: 'Nord-Marianene',
    NO: 'Norge',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua Ny-Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filippinene',
    PN: 'Pitcairn',
    PL: 'Polen',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    SS: 'Republikken Sør-Sudan',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Den Russiske Føderasjonen',
    RW: 'Rwanda',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent og Grenadinene',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychellene',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon øyene',
    SO: 'Somalia',
    ZA: 'Sør-Afrika',
    GS: 'Sør-Georgia Sør-Sandwichøyene',
    ES: 'Spania',
    LK: 'Sri Lanka',
    SH: 'St. Helena',
    PM: 'St. Pierre og Miquelon',
    SD: 'Sudan',
    SR: 'Surinam',
    SJ: 'Svalbarn og Jan Mayen-øyene',
    SZ: 'Swaziland',
    SE: 'Sverige',
    CH: 'Sveits',
    SY: 'Den syriske arabiske republikk',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Den forente republikk Tanzania',
    TH: 'Thailand',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad og Tobago',
    TN: 'Tunisia',
    TR: 'Tyrkia',
    TM: 'Turkmenistan',
    TC: 'Turks- og Caicosøyene',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraina',
    AE: 'De forente arabiske emirater',
    GB: 'Storbritannia',
    UM: 'USAs ytre øyer',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VU: 'Vanuatu',
    VA: 'Vatikanstaten',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Jomfruøyene (britiske)',
    VI: 'Jomfruøyene (USA)',
    WF: 'Wallis og Futuna-øyene',
    EH: 'Vestre Sahara',
    YE: 'Jemen',
    YU: 'Jugoslavia',
    ZR: 'Zaire',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};



// WEBPACK FOOTER //
// ./src/app/locale/no/country.js